import { loadShared } from './dashboardCache';

// What a click on a CRO's student count on the MAU page opens: the students behind the number (see
// mau_students.controller.js on the server). One place builds the URL, so the page that PREFETCHES on hover and the popup
// that LOADS on click share the very same remembered answer (dashboardCache.js).
export const STUDENT_KIND_LABEL = { new: 'New students', active: 'Active students' };

export const mauStudentsUrl = ({ kind, userId, month }) => {
  const params = new URLSearchParams({ kind, userId: String(userId), month: month.format('YYYY-MM-DD') });
  return `warning-dashboard/mau-students?${params.toString()}`;
};

// Warm the remembered answer (no UI): called when the pointer rests on a count, so by the click it is usually there.
export const prefetchMauStudents = (request) => {
  loadShared(mauStudentsUrl(request)).catch(() => {});
};
